import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "3191d481-c532-465f-b0b6-ecd8e20ecb17",
    content: " Around 80 Hz when paired<br>to a consumer product",
    options: {},
  },
  {
    id: "ffe6c0ca-ef42-4002-acf7-c8a438893a7a",
    content: "Around 200 Hz when paired<br>to a consumer audio system",
    options: {},
  },
  { id: "9ca4c31f-5d12-4dd1-b9be-256eb4e74def", content: "80 Hz for THX movie theaters", options: {} },
  { id: "dc268f40-67ef-4184-a557-97bd865f4126", content: "Below 100 Hz for live sound systems", options: {} },
  { id: "61a33fd1-dd72-4eb5-9dad-bc4ccf4e79eb", content: "200 Hz for movie theaters", options: {} },
  { id: "1895ea01-c741-443d-b2a8-16d3b99dbfc6", content: "Around 200 Hz for live sound systems", options: {} },
];

export const task: Task = {
  id: "7ff25838-d090-4fbe-bfdc-9f1ef05ee982",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "ffe6c0ca-ef42-4002-acf7-c8a438893a7a",
    "9ca4c31f-5d12-4dd1-b9be-256eb4e74def",
    "dc268f40-67ef-4184-a557-97bd865f4126",
  ],
};
